import React from 'react'
import i18next from 'i18next'

import Button from 'app/components/ButtonDefault'
import ModalBody from 'app/components/Modal/ModalBody'
import RotateRight from 'app/components/SVGS/RotateRight'
import './styles.scss'

const bc = 'refresh-cache-modal'

const RefreshCacheModal = ({ onRequestClose }) => {
  return (
    <ModalBody onRequestClose={onRequestClose} className={`${bc}__wrapper-popup`}>
      <div className={`${bc}__content`}>
        <p className={`${bc}__text`}>{i18next.t('Please press refresh cache button above')}</p>
        <div className={`${bc}__icon`}>
          <RotateRight
            svgProps={{
              width: 15,
              height: 15,
            }}
            pathProps={{
              fill: '#fff',
            }}
          />
        </div>
        <p className={`${bc}__text`}>{i18next.t(`once you've finished with all the edits`)}</p>
      </div>
      <div className={`${bc}__button`}>
        <Button lg onClick={onRequestClose}>
          {i18next.t('Ok')}
        </Button>
      </div>
    </ModalBody>
  )
}

export default RefreshCacheModal
